import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useRef } from 'react'
import { MoneyCashFormContainer } from 'refunds/containers/MoneyCashFormContainer/MoneyCashFormContainer'
import type { MoneyCashInfo, RefundData } from 'refunds/types/refundData'

import style from './MoneyCashModal.module.scss'

interface MoneyCashModalProps {
	readonly refundData?: RefundData
	readonly handleOnError?: () => void
	readonly handleOnClose?: () => void
	readonly handleOnSave?: (values: MoneyCashInfo) => void
}

export function MoneyCashModal({
	refundData,
	handleOnError,
	handleOnClose,
	handleOnSave,
}: MoneyCashModalProps) {
	const { t } = useLabels()
	const modalRef = useRef<ModalAPI>(null)

	useEffect(() => {
		modalRef.current?.show()
	}, [modalRef.current])

	const handleSave = (values: MoneyCashInfo) => {
		modalRef.current?.close()
		handleOnSave?.(values)
	}

	return (
		<Modal
			showTitle
			name='money-cash-form-modal'
			title={t('form.refunds.cash.refundInfo.title')}
			ref={modalRef}
			onClose={handleOnClose}
			type={MODAL_TYPE.SHEET}
			data-testid='refunds.modal.moneyCash'
			className={style.container}
		>
			<MoneyCashFormContainer
				refundData={refundData}
				handleOnError={handleOnError}
				handleOnSave={handleSave}
			/>
		</Modal>
	)
}
